export default __webpack_public_path__ + "static/media/ThreePigs_12.893854cb.png";